import React, { useState, useEffect, useCallback } from "react";
import { styled } from "@mui/styles";
import axios from "../plugins/axios";
import {
    Card as MuiCard,
    CardContent as MuiCardContent,
    Typography as MuiTypography,
    Box,
    Chip as MuiChip,
} from "@mui/material";

import { spacing } from "@mui/system";

const apiUrl = process.env.REACT_APP_CASENEST_API_URL;

const Typography = styled(MuiTypography)(spacing);

const Card = styled(MuiCard)(spacing);

const CardContent = styled(MuiCardContent)(({ theme }) => ({    
    position: 'relative',

    '&:last-child': {
        paddingBottom: theme.spacing(4)
    }
}));

const Chip = styled(MuiChip)(({ theme }) => ({
    position: 'absolute',
    top: '16px',
    right: '16px',
    height: '20px',
    padding: '4px 0',
    fontSize: '85%',
    backgroundColor: theme.palette.secondary.main,
    color: theme.palette.common.white,
    marginBottom: theme.spacing(4),

    '& span': {
        paddingLeft: theme.spacing(2),
        paddingRight: theme.spacing(2),
    }
}));

const UserSLACard = ({ userProfile, fromDate, toDate }) => {
    const [sla, setSla] = useState("-");

    const getSla = useCallback(async () => {
        if (
            (!fromDate && toDate) ||
            (fromDate && !toDate) ||
            !userProfile.userId
        )
            return;
        const response = await axios.post(`${apiUrl}/getusersla`, {
            userId: userProfile.userId,
            fromDate,
            toDate,
        });
        if (response.status === 200 && !isNaN(response.data)) {
            setSla(Math.round(response.data * 100) + "%");
            return;
        }
        setSla("N/A");
    }, [userProfile.userId, fromDate, toDate]);

    useEffect(() => {
        getSla();
    }, [getSla]);

    return (
        <Card mb={3} style={{ height: "100%" }}>
            <CardContent>
                <Typography variant="h6" mb={6}>
                    My SLA
                </Typography>
                <Typography variant="h2" mb={6}>
                    <Box
                        display="flex"
                        justifyContent="center"
                        fontWeight="fontWeightRegular"
                    >
                        {sla}
                    </Box>
                </Typography>
                <Chip
                    label={!(toDate && fromDate) ? "All" : "Custom date range"}
                />
            </CardContent>
        </Card>
    );
};

export default UserSLACard;